import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('ui.components.ComponentErrorBoundary.ErrorPlaceholder', {
    weCouldntLoad: 'We couldn’t load the content',
    pleaseReloadThisPage: 'Please reload this page',
    contactSupport: 'Contact support',
});
